function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.13,7.73l-.67-.67a1.9,1.9,0,0,0-2.68,0h0L12.31,18.48l-4.07-4a1.92,1.92,0,0,0-2.7,0l-.67.67a1.9,1.9,0,0,0,0,2.68h0L11,23.93a1.9,1.9,0,0,0,2.68,0h0L27.13,10.42A1.91,1.91,0,0,0,27.13,7.73Z",
    style: {
      fill: "#6eb005"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.3c59a2de.svg";
export { ForwardRef as ReactComponent };